// extracted by mini-css-extract-plugin
export default {"cookieBand":"RnMX4zx5","showBand":"esGkDDe4","active":"zGcQuVwh","textArea":"o7pLvUcN","text":"NES8UFx2","line":"If9LTxtv","buttons":"ZGjRbyG9"};